import { Link } from 'react-router';
import type { ClosedReason } from '@/stores/roomStore';

const MESSAGES: Record<ClosedReason, { emoji: string; title: string; text: string }> = {
  expired: { emoji: '⏰', title: '종료되었거나 만료된 방입니다.', text: '새로운 방을 만들어 동료들과 다시 시작해보세요.' },
  host: { emoji: '👋', title: '방장이 방을 종료했어요.', text: '오늘 점심 맛있게 드세요!' },
  empty: { emoji: '🍃', title: '참여자가 모두 나가 방이 종료됐어요.', text: '새로운 방을 만들어 다시 시작할 수 있어요.' },
  kicked: { emoji: '🚪', title: '방장이 당신을 내보냈어요.', text: '다른 방에 참여하거나 새 방을 만들어보세요.' },
  unauthorized: { emoji: '🔒', title: '참여 정보가 유효하지 않아요.', text: '다시 입장해주세요.' },
  left: { emoji: '👋', title: '방에서 나왔어요.', text: '언제든 새로운 방을 만들 수 있어요.' },
};

export function ClosedView({ reason, roomId, message }: { reason: ClosedReason; roomId?: string; message?: string | null }) {
  const m = MESSAGES[reason];
  return (
    <div className="card flex flex-col items-center gap-4 p-8 text-center animate-fade-up">
      <span className="text-5xl" aria-hidden="true">
        {m.emoji}
      </span>
      <h1 className="text-xl font-bold break-keep">{m.title}</h1>
      <p className="text-sm text-charcoal-500">{message ?? m.text}</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Link to="/create" className="btn-primary btn-md">
          새로운 방 만들기
        </Link>
        {reason === 'unauthorized' && roomId && (
          <Link to={`/room/${roomId}`} reloadDocument className="btn-secondary btn-md">
            다시 입장하기
          </Link>
        )}
        <Link to="/" className="btn-ghost btn-md">
          홈으로
        </Link>
      </div>
    </div>
  );
}
